// @/api/payment.js
import axios from 'axios'

export default {
  createPayment(data) {
    return axios({
      url: '/pay/payment/create', // 实际请求地址需根据项目配置调整
      method: 'post',
      data
    })
  }
}